import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dimensionCategoriesSelector } from "./dimensionCategoriesSelector";

export const dimensionCategoriesEntriesSelector = createDraftSafeSelector(
  [dimensionCategoriesSelector],
  (categories) => Object.entries(categories),
);
